export const GET_CLAIMS_SUCCESS = 'adjudication/GET_CLAIMS_SUCCESS';
export const GET_CLAIM_SUCCESS = 'adjudication/GET_CLAIM_SUCCESS';
export const SET_CLAIM_TYPES = 'adjudication/SET_CLAIM_TYPES';
export const ADD_MEMBER_NOTE = 'adjudication/ADD_MEMBER_NOTE';
export const UPDATE_CLAIM = 'adjudication/UPDATE_CLAIM';
export const GET_PREDETERMINATIONS_SUCCESS = 'adjudication/GET_PREDETERMINATIONS_SUCCESS';
export const REMOVE_PREDETERMINATION = 'adjudication/REMOVE_PREDETERMINATION';